const header = document.querySelector('.header');

const observeFixed = () => {
  let body = document.body;
  let breakpointLg = window.matchMedia('(min-width: 1024px)');
  let fixedBlocks = document.querySelectorAll('.will-fixed');
  let mainBottle = document.querySelector('#main-bottle');

  let observer = new MutationObserver(() => {
    if (breakpointLg.matches) {
      if (header) {
        header.style.paddingRight = body.style.paddingRight;
      }

      if (mainBottle) {
        // mainBottle.style.left = 'unset';
        mainBottle.style.marginRight = body.style.paddingRight;
      }

      if (fixedBlocks.length) {
        fixedBlocks.forEach((e) => {
          e.style.paddingRight = body.style.paddingRight;
        });
      }
    }
  });

  observer.observe(body, {attributes: true});
};

export {observeFixed};
